import { TAIntro } from '~/modules/applications/pages/CourseDashboardPage/blocks/components/TAIntro/TAIntro';
import { TASuccess } from '~/modules/applications/pages/CourseDashboardPage/blocks/components/TASuccess/TASuccess';

export const TAApplicationStatus = ({application, course}) => {

  const hasEnrolled = application.wants_to_enroll
  return (
    <>
      <div className="narrow mt-20 ta-dashboard">
          {!hasEnrolled ? (<TAIntro application={application} />) :
              (<TASuccess application={application} />)
          }
      </div>
    </>
  );
};
